import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { css } from '@emotion/core';
import { FLEX_ROW } from '../../layout/flexBox';
import { Str } from '../../localization/translationKeys';
import { faCheck, faPlus } from '@fortawesome/free-solid-svg-icons';
import { Z_INDEX } from '../../globalStyle/zIndex';
import { COLORS } from '../../globalStyle/colors';
import { btnStyle } from '../../forms/styles/button';
import MobileToolbarBtn from '../../localization/MobileToolbarBtn';


const styles = {
  root:   css`
    justify-content: flex-end;
    width: 100vw;
    height: 72px;
    position: fixed;
    bottom: 0;
    z-index: ${Z_INDEX.MOBILE_TOOLBAR};
    background-color: ${COLORS.WHITE};
  `,
  button: css`
    font-size: 9px;
    border-radius: 0;
    flex-basis: 80px;
    border-color: transparent;
    height: 72px;
    line-height: normal;
    & span {
      overflow-wrap: break-spaces;
      text-transform: uppercase;
    }
  `,
  hide: css`
    display: none;
  `,
};


type Props = {
  className?: string;
  addDisabled: boolean;
  addCaption: string;
  addClicked: () => void;
  createDisabled: boolean;
  createdMode: boolean;
  unsetCreated: () => void;
  applyPendingChanges: () => void;
}


/**
 * MobileCreateSurveyActionsBar: a tool bar housint action buttons associated with the create survey flow
 * screens.
 *
 * PureComponent: true
 * Redux Connected: false
 */
const MobileCreateSurveyActionsBar: React.FC<Props> = props => (
  ReactDOM.createPortal(
    <div css={[FLEX_ROW, styles.root]}>
      <MobileToolbarBtn
        css={[btnStyle.secondary(COLORS.DARK_GREY), props.createdMode && styles.hide, styles.button]}
        str=''
        defaultText={props.addCaption}
        icon={faPlus}
        onClick={() => props.addClicked()}
        disabled={props.addDisabled}
      />
      <MobileToolbarBtn
        css={[btnStyle.primary(props.createdMode ? COLORS.BLUE : COLORS.GREEN), styles.button]}
        str={props.createdMode ? Str.EditSurvey : Str.CreateSurvey}
        icon={faCheck}
        onClick={() => props.createdMode ? props.unsetCreated() : props.applyPendingChanges()}
        disabled={props.createDisabled}
      />
    </div>
    ,
    document.getElementById('root') || document.getElementById('react-root') || document.body,
  )
);

export default MobileCreateSurveyActionsBar;
